import { NgModule } from '@angular/core';

import { SharedModule } from "../../../shared/shared.module";
import { LocalidadeTiposApiService } from "./localidade-tipos-api.service";

@NgModule({
  imports: [
    SharedModule
  ],
  providers: [
    LocalidadeTiposApiService
  ],
  declarations: []
})
export class LocalidadeTiposModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/localidades/localidades-tipos/localidade-tipos.module.ts
 **/